import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from 'react';
// Import Components (SVGS)
import { Facebook } from '../svgs/Facebook';
import { LinkedIn } from '../svgs/LinkedIn';
import { Twitter } from '../svgs/Twitter';
import { Instagram } from '../svgs/Instagram';
import { Pinterest } from '../svgs/Pinterest';
import { Link } from '@jelly/ui';

var SocialMediaIconLink = /*#__PURE__*/_styled(Link, {
  target: "e137afox0",
  label: "SocialMediaIconLink"
})(process.env.NODE_ENV === "production" ? {
  name: "fidq99",
  styles: "margin-right:10px;height:30px;svg{width:30px;height:30px;}"
} : {
  name: "fidq99",
  styles: "margin-right:10px;height:30px;svg{width:30px;height:30px;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var SOCIAL_BUTTONS = {
  facebook: Facebook,
  twitter: Twitter,
  linkedin: LinkedIn,
  instagram: Instagram,
  pinterest: Pinterest
};
/**
 * This is the Social Media Component for non-bdc related social media groups
 */

export var SocialProfileButtons = function SocialProfileButtons(_ref) {
  var _ref$buttons = _ref.buttons,
      buttons = _ref$buttons === void 0 ? {} : _ref$buttons,
      color = _ref.color,
      name = _ref.name,
      backgroundColor = _ref.backgroundColor,
      _ref$rel = _ref.rel,
      rel = _ref$rel === void 0 ? '' : _ref$rel,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'neutral' : _ref$variant;
  return Object.keys(buttons).reduce(function (withLinksList, social) {
    var SocialIcon = SOCIAL_BUTTONS[social];

    if (buttons[social] && SOCIAL_BUTTONS[social]) {
      var altText = "".concat(name, " ").concat(social);
      var relAttribute = "noopener noreferrer ".concat(rel);
      return [].concat(_toConsumableArray(withLinksList), [/*#__PURE__*/React.createElement(SocialMediaIconLink, {
        key: altText,
        alt: altText,
        href: buttons[social],
        rel: relAttribute,
        target: "_blank",
        backgroundColor: backgroundColor
      }, /*#__PURE__*/React.createElement(SocialIcon, {
        color: color,
        backgroundColor: backgroundColor,
        variant: variant
      }))]);
    }

    return _toConsumableArray(withLinksList);
  }, []);
};